import React, {FC, useEffect, useState} from "react";
import {transactionService} from "../../../store/actions";
import {useParams} from "react-router-dom";
import BSkeletonList from "../../../components/b-skeleton/b-skeleton-list";
import BCopy from "../../../components/b-copy";
import {useTranslation} from "react-i18next";
import BEmpty from "../../../components/b-empty";

interface TransactionRowTraceProps {
}

interface TransactionRowTraceData {
}

const TransactionRowTrace: FC<TransactionRowTraceProps> = (props) => {
    const {hash} = useParams();
    const [loading, setLoading] = useState(true);
    const {t, i18n} = useTranslation();
    const [transactionList, setTransactionList] = useState<any>([]); //overview, events

    const getTransaction = async () => {
        try {
            setLoading(true);
            transactionService
                .getTransactionRowTrace(hash)
                .then((response) => {
                    setTransactionList(response);
                    setLoading(false);
                })
                .catch((e) => setLoading(false));
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getTransaction();
    }, []);

    return (
        <React.Fragment>
      {!!transactionList.length ? (
          <React.Fragment>
          <div className="d-flex align-items-center justify-content-end my-3 mx-2">
            <BCopy
                value={JSON.stringify(transactionList)}
                tooltip={`${t("Tx row trace to clipboard")}`}
            />
          </div>
          <div className="bs-card mb-3 bs-list-log-data transaction-trace">
            {loading ? (
                <BSkeletonList length={10} col={3}/>
            ) : (
                <pre>{JSON.stringify(transactionList, null, 2)}</pre>
            )}
          </div>
          </React.Fragment>
      ) : (
          <div className="bs-card mb-3 bs-list-log-data transaction-trace">
              {loading ? (
                  <BSkeletonList length={10} col={3}/>
              ) : (
                  <BEmpty text={`${t("No trace entries found.")}`}/>
              )}
          </div>
      )}
        </React.Fragment>
    );
};

export default TransactionRowTrace;
